module.exports = __webpack_public_path__ + "img/IMG_9294.900f5a17.jpg";